/**
 * @flow
 */

import React from 'react';
import withModal from '../../../../lib/withModal';
import EditManufacturerDialog from '../../containers/manufacturers/EditManufacturerDialog';
import { FormattedMessage } from 'react-intl';
import type { Manufacturer, ModalDialogTrigger } from '../../../../type';

type EditManufacturerButtonProps = {
    manufacturer: Manufacturer,
} & ModalDialogTrigger;

const EditManufacturerButton = ({
    manufacturer,
    open,
    onOpen,
    onClose,
    children,
}: EditManufacturerButtonProps) => (
    <EditManufacturerDialog
        trigger={
            <a onClick={onOpen}>
                <FormattedMessage
                    id="pages.settings.manufacturers.edit"
                    defaultMessage="Edit"
                />
            </a>
        }
        onClose={onClose}
        open={open}
        manufacturer={manufacturer}
    />
);

export default withModal(EditManufacturerButton);
